
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';

  @Component({
    components: {
      AppDialog,
    },
  })
  export default class InputCarNumberPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'allPages', dialogName: 'inputCarNumber' };
    animateDisplay = false;

    formModel = {
      carNumber: '',
    }
    formRules = {
      carNumber: [{
        validator: (rule, value, callback) => {
          let valid = value.length >= 7 && value.length <= 9;
          return valid ? callback() : callback(new Error('Номер должен состоять из 7-9 знаков'))
        },
        required: true,
        message: 'Номер должен состоять из 7-9 знаков',
        trigger: 'blur'
      }],
    };

    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }

    async mounted() {
      setTimeout(async () => {
        this.animateDisplay = true;
        await this.$nextTick();
        const inputNumber: any = this.$refs.carNumber;
        if (inputNumber) inputNumber.focus();
      }, 0);
    }

    async confirmAction() {
      this.$refs.carNumberForm.validate(async (valid) => {
        if (!valid) return false;

        if (this.payloadPopup.confirmAction) {
          await this.payloadPopup.confirmAction(this.formModel);
          await this.onClose();
        }

      });
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }

  }
